import { graphql } from '../../graphql';

export const getStaticPage = graphql(`
  query GetStaticPage($slug: String!) {
    page(slug: $slug) {
      id
      slug
      title
      content
    }
  }
`);
